import React from 'react';
import { motion } from 'framer-motion';
export function StatsBar() {
  const stats = [{
    number: '+5',
    text: 'años en gastronomía'
  }, {
    number: '+3',
    text: 'años en marketing gastronómico'
  }, {
    number: '×10',
    text: 'ventas escaladas'
  }];
  return <section className="bg-accent/10 border-t border-accent relative z-20" data-id="element-143">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12" data-id="element-144">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-0 divide-y md:divide-y-0 md:divide-x divide-accent/20" data-id="element-145">
          {stats.map((stat, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="flex flex-col items-center justify-center text-center px-4 py-6 md:py-0" data-id="element-146">
              <span className="text-5xl md:text-6xl font-black text-gradient mb-2 font-heading" data-id="element-147">
                {stat.number}
              </span>
              <span className="text-white font-medium text-lg max-w-[200px]" data-id="element-148">
                {stat.text}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}